export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 订单管理-快速下单管理-快速下单列表
  {
    path: 'quickOrderList',
    name: 'quickOrderList',
    meta: {
      title: '快速下单管理',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['quickOrderList']
    },
    component: function component() {
      return import('@/pages/orderModule/quickOrderMenu/quickOrder/quickOrderList.vue');
    }
  }, // 订单管理-快速下单管理- 新增快速下单
  {
    path: 'quickOrderAdd',
    name: 'quickOrderAdd',
    meta: {
      title: '新增快速下单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/quickOrderMenu/quickOrder/quickOrderAdd.vue');
    }
  }, // 订单管理-快速下单管理- 修改快速下单
  {
    path: 'quickOrderEdit',
    name: 'quickOrderEdit',
    meta: {
      title: '修改快速下单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/quickOrderMenu/quickOrder/quickOrderEdit.vue');
    }
  }, // 订单管理-快速下单管理-详情
  {
    path: 'quickOrderDetail',
    name: 'quickOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/quickOrderMenu/quickOrder/quickOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-我的订单
  {
    path: 'ecMyOrder',
    name: 'ecMyOrder',
    meta: {
      title: '我的订单',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecMyOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecMyOrder/ecMyOrder.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-我的订单-确认付款
  {
    path: 'ecCommerceConfirmPay',
    name: 'ecCommerceConfirmPay',
    meta: {
      title: '待确认付款',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecMyOrder/ecCommerceConfirmPay.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-订单详情
  {
    path: 'orderDetail',
    name: 'orderDetail',
    meta: {
      title: '订单详情',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/orderDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-收发货详情
  {
    path: 'receivingAddressDetail',
    name: 'receivingAddressDetail',
    meta: {
      title: '收发货详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/receivingAddressDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-订单审批
  {
    path: 'ecApprovalOrder',
    name: 'ecApprovalOrder',
    meta: {
      title: '订单审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecApprovalOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecApprovalOrder/ecApprovalOrder.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-订单审批-单个订单审批
  {
    path: 'ecApprovalOrderDetail',
    name: 'ecApprovalOrderDetail',
    meta: {
      title: '订单审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecApprovalOrder/ecApprovalOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-我的取消申请
  {
    path: 'ecMyCancleApplication',
    name: 'ecMyCancleApplication',
    meta: {
      title: '我的取消申请',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecMyCancleApplication']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecMyCancleApplication/ecMyCancleApplication.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-我的取消申请-取消订单详情
  {
    path: 'ecCancleOrderDetail',
    name: 'ecCancleOrderDetail',
    meta: {
      title: '取消订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecMyCancleApplication/ecCancleOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-到货验收
  {
    path: 'ecArrivalAcceptance',
    name: 'ecArrivalAcceptance',
    meta: {
      title: '到货验收',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecArrivalAcceptance']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecArrivalAcceptance/ecArrivalAcceptance.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-售后申请列表
  {
    path: 'ecAfterSalesApplication',
    name: 'ecAfterSalesApplication',
    meta: {
      title: '售后申请列表',
      cache: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecAfterSalesApplication/ecAfterSalesApplication.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-售后申请列
  {
    path: 'ecAfterSalesSubmit',
    name: 'ecAfterSalesSubmit',
    meta: {
      title: '售后申请提交',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecAfterSalesApplication/ecAfterSalesSubmit.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-售后管理
  {
    path: 'ecAfterSalesManagement',
    name: 'ecAfterSalesManagement',
    meta: {
      title: '售后管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecAfterSalesManagement']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecAfterSalesManagement/ecAfterSalesManagement.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-售后管理详情
  {
    path: 'ecAfterSalesManagementDetail',
    name: 'ecAfterSalesManagementDetail',
    meta: {
      title: '售后详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecAfterSalesManagement/ecAfterSalesManagementDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-维护发运信息
  {
    path: 'ecMaintainShipInfoDetail',
    name: 'ecMaintainShipInfoDetail',
    meta: {
      title: '维护发运信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecAfterSalesManagement/ecMaintainShipInfoDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-订单异常变更
  {
    path: 'ecExceptionOrder',
    name: 'ecExceptionOrder',
    meta: {
      title: '订单异常变更',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecExceptionOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecExceptionOrder/ecExceptionOrder.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-订单异常变更-数量/状态
  {
    path: 'ecExceptionOrderChange',
    name: 'ecExceptionOrderChange',
    meta: {
      title: '订单异常变更',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecExceptionOrder/ecExceptionOrderChange.vue');
    }
  }, // 内部采购企业-订单管理-电商订单统计查询-订单查询
  {
    path: 'ecInquiryOrder',
    name: 'ecInquiryOrder',
    meta: {
      title: '订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecInquiryOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecInquiryOrder/ecInquiryOrder.vue');
    }
  }, // 内部采购企业-订单管理-电商订单统计查询-售后查询
  {
    path: 'ecAfterSalesSearch',
    name: 'ecAfterSalesSearch',
    meta: {
      title: '售后查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecAfterSalesSearch']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecAfterSalesSearch/ecAfterSalesSearch.vue');
    }
  }, // 内部采购企业-订单管理-电商订单统计查询-售后详情
  {
    path: 'ecAfterSalesSearchDetail',
    name: 'ecAfterSalesSearchDetail',
    meta: {
      title: '售后详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecAfterSalesSearch/ecAfterSalesSearchDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单统计查询-订单异常变更查询
  {
    path: 'ecExceptionChangeOrder',
    name: 'ecExceptionChangeOrder',
    meta: {
      title: '订单异常变更查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecExceptionChangeOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecExceptionChangeOrder/ecExceptionChangeOrder.vue');
    }
  }, // 内部采购企业-订单管理-电商订单统计查询-订单异常变更详情
  {
    path: 'ecExceptionStatusCountChangeDetail',
    name: 'ecExceptionStatusCountChangeDetail',
    meta: {
      title: '订单异常变更详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecExceptionChangeOrder/ecExceptionStatusCountChangeDetail.vue');
    }
  }, // 运营管理-订单管理-电商订管理-订单异常变更确认
  {
    path: 'ecExceptionConfirmOrder',
    name: 'ecExceptionConfirmOrder',
    meta: {
      title: '订单异常变更确认',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecExceptionConfirmOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderMenu/ecExceptionConfirmOrder/ecExceptionConfirmOrder.vue');
    }
  }, // 运营管理-订单管理-评价管理-查看评价详情
  {
    path: 'evaluationOrderDetail',
    name: 'evaluationOrderDetail',
    meta: {
      title: '查看评价详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/evaluateMenu/evaluationOrderDetail.vue');
    }
  }, // 运营管理-订单管理-评价管理-查看审批评价详情
  {
    path: 'aprovalEvaluationOrderDetail',
    name: 'aprovalEvaluationOrderDetail',
    meta: {
      title: '查看评价详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/evaluateMenu/aprovalEvaluationOrderDetail.vue');
    }
  }, // 运营管理-订单管理-评价管理-查看审批评价详情
  {
    path: 'aprovalEvaluationOrder',
    name: 'aprovalEvaluationOrder',
    meta: {
      title: '评价审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/evaluateMenu/aprovalEvaluationOrder.vue');
    }
  }, // 运营管理-订单管理-评价管理-评价审批
  {
    path: 'aprovalEvaluate',
    name: 'aprovalEvaluate',
    meta: {
      title: '评价审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['aprovalEvaluate']
    },
    component: function component() {
      return import('@/pages/orderModule/evaluateMenu/aprovalEvaluate/aprovalEvaluate.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-销售订单列表
  {
    path: 'ecSalesOrderQuery',
    name: 'ecSalesOrderQuery',
    meta: {
      title: '销售订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecSalesOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecSalesOrderQuery/ecSalesOrderQuery.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-销售订单详情
  {
    path: 'ecSalesOrderQueryDetail',
    name: 'ecSalesOrderQueryDetail',
    meta: {
      title: '销售订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecSalesOrderQuery/ecSalesOrderQueryDetail.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-采购订单查询
  {
    path: 'ecPurchaseOrderQuery',
    name: 'ecPurchaseOrderQuery',
    meta: {
      title: '采购订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecPurchaseOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecPurchaseOrderQuery/ecPurchaseOrderQuery.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-采购订单详情
  {
    path: 'ecPurchaseOrderQueryDetail',
    name: 'ecPurchaseOrderQueryDetail',
    meta: {
      title: '采购订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecPurchaseOrderQuery/ecPurchaseOrderQueryDetail.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-三方交易模式订单
  {
    path: 'ecMatchingOrderQuery',
    name: 'ecMatchingOrderQuery',
    meta: {
      title: '三方交易模式订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecMatchingOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecMatchingOrderQuery/ecMatchingOrderQuery.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-三方交易模式订单详情
  {
    path: 'ecMatchingOrderQueryDetail',
    name: 'ecMatchingOrderQueryDetail',
    meta: {
      title: '三方交易模式订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/ecOrderCountMenu/ecMatchingOrderQuery/ecMatchingOrderQueryDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的订单
  {
    path: 'agrMyOrder',
    name: 'agrMyOrder',
    meta: {
      title: '我的订单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMyOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyOrder/agrMyOrder.vue');
    }
  }, // 智能客服回调中转页面
  {
    path: 'customSerToOrder',
    name: 'customSerToOrder',
    meta: {
      title: '我的订单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyOrder/customSerToOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的订单-确认付款
  {
    path: 'agrConfirmPay',
    name: 'agrConfirmPay',
    meta: {
      title: '确认付款',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyOrder/agrConfirmPay.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的订单-到货验收
  {
    path: 'agrConfirmReciving',
    name: 'agrConfirmReciving',
    meta: {
      title: '到货验收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyOrder/agrConfirmReciving.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的订单-到货确认/拒收
  {
    path: 'agrArrivalConfirmation',
    name: 'agrArrivalConfirmation',
    meta: {
      title: '到货确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyOrder/agrArrivalConfirmation.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-查看收发货详情
  {
    path: 'agrReceivingAddressDetail',
    name: 'agrReceivingAddressDetail',
    meta: {
      title: '收发货详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrReceivingAddressDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单详情
  {
    path: 'agrOrderDetail',
    name: 'agrOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单详情
  {
    path: 'purAgrOrderDetail',
    name: 'purAgrOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/purAgrOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单分配
  {
    path: 'agrAllocationOrder',
    name: 'agrAllocationOrder',
    meta: {
      title: '订单分配',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrAllocationOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrAllocationOrder/agrAllocationOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单复核
  {
    path: 'agrReviewCheckOrder',
    name: 'agrReviewCheckOrder',
    meta: {
      title: '订单复核',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrReviewCheckOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrReviewCheckOrder/agrReviewCheckOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-复核订单
  {
    path: 'agrReviewOrder',
    name: 'agrReviewOrder',
    meta: {
      title: '复核订单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrReviewCheckOrder/agrReviewOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的待处理订单
  {
    path: 'agrMyPendingOrders',
    name: 'agrMyPendingOrders',
    meta: {
      title: '我的待处理订单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMyPendingOrders']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyPendingOrders/agrMyPendingOrders.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-调价核实
  {
    path: 'agrAdjustConfirm',
    name: 'agrAdjustConfirm',
    meta: {
      title: '调价核实',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyPendingOrders/agrAdjustConfirm.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的取消申请
  {
    path: 'agrMyCancleApply',
    name: 'agrMyCancleApply',
    meta: {
      title: '我的取消申请',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMyCancleApply']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyCancleApply/agrMyCancleApply.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-取消申请详情
  {
    path: 'agrCancleOrderDetail',
    name: 'agrCancleOrderDetail',
    meta: {
      title: '取消申请详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyCancleApply/agrCancleOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单审批列表
  {
    path: 'agrApprovalOrder',
    name: 'agrApprovalOrder',
    meta: {
      title: '订单审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrApprovalOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrApprovalOrder/agrApprovalOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单审批
  {
    path: 'agrApprovalOrderDetail',
    name: 'agrApprovalOrderDetail',
    meta: {
      title: '订单审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrApprovalOrder/agrApprovalOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-到货验收
  {
    path: 'agrArrivalAcceptance',
    name: 'agrArrivalAcceptance',
    meta: {
      title: '到货验收',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrArrivalAcceptance']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrArrivalAcceptance/agrArrivalAcceptance.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-售后管理
  {
    path: 'agrAfterSalesManagement',
    name: 'agrAfterSalesManagement',
    meta: {
      title: '售后管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrAfterSalesManagement']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrAfterSalesManagement/agrAfterSalesManagement.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-查看服务单详情
  {
    path: 'agrViewServiceDetail',
    name: 'agrViewServiceDetail',
    meta: {
      title: '查看服务单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrAfterSalesManagement/agrViewServiceDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-售后申请提交
  {
    path: 'agrAfterSalesSubmit',
    name: 'agrAfterSalesSubmit',
    meta: {
      title: '售后申请提交',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrAfterSalesManagement/agrAfterSalesSubmit.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单异常变更
  {
    path: 'agrExceptionOrder',
    name: 'agrExceptionOrder',
    meta: {
      title: '订单异常变更',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrExceptionOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrExceptionOrder/agrExceptionOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-数量变更发起
  {
    path: 'agrExceptionOrderChange',
    name: 'agrExceptionOrderChange',
    meta: {
      title: '数量变更发起',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrExceptionOrder/agrExceptionOrderChange.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-订单查询
  {
    path: 'agrInquiryOrder',
    name: 'agrInquiryOrder',
    meta: {
      title: '订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrInquiryOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrInquiryOrder/agrInquiryOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-订单调价查询
  {
    path: 'agrAdjustmentQuery',
    name: 'agrAdjustmentQuery',
    meta: {
      title: '订单调价查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrAdjustmentQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrAdjustmentQuery/agrAdjustmentQuery.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-订单调价详情
  {
    path: 'agrAdjustmentQueryDetail',
    name: 'agrAdjustmentQueryDetail',
    meta: {
      title: '订单调价详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrAdjustmentQuery/agrAdjustmentQueryDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-售后查询
  {
    path: 'agrAfterSalesSearch',
    name: 'agrAfterSalesSearch',
    meta: {
      title: '售后查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrAfterSalesSearch']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrAfterSalesSearch/agrAfterSalesSearch.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-服务单详情
  {
    path: 'agrAfterSalesSearchDetail',
    name: 'agrAfterSalesSearchDetail',
    meta: {
      title: '服务单详情',
      cache: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrAfterSalesSearch/agrAfterSalesSearchDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-订单异常变更查询
  {
    path: 'agrExceptionOrderQuery',
    name: 'agrExceptionOrderQuery',
    meta: {
      title: '订单异常变更查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrExceptionOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrExceptionOrderQuery/agrExceptionOrderQuery.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-数量变更单详情
  {
    path: 'agrExceptionOrderQueryDetail',
    name: 'agrExceptionOrderQueryDetail',
    meta: {
      title: '服务单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrExceptionOrderQuery/agrExceptionOrderQueryDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的贸易销售订单
  {
    path: 'agrTradeSalesOrder',
    name: 'agrTradeSalesOrder',
    meta: {
      title: '我的贸易销售订单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrTradeSalesOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrTradeSalesOrder/agrTradeSalesOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的贸易销售订单-调价核实
  {
    path: 'agrAdjustVerification',
    name: 'agrAdjustVerification',
    meta: {
      title: '调价核实',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrTradeSalesOrder/agrAdjustVerification.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的三方交易销售订单
  {
    path: 'agrMyMatchingSalesOrder',
    name: 'agrMyMatchingSalesOrder',
    meta: {
      title: '我的三方交易销售订单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMyMatchingSalesOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyMatchingSalesOrder/agrMyMatchingSalesOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的三方交易销售订单-调价核实
  {
    path: 'agrBusAdjustConfirm',
    name: 'agrBusAdjustConfirm',
    meta: {
      title: '调价核实',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyMatchingSalesOrder/agrBusAdjustConfirm.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的采购订单
  {
    path: 'agrMyPurchaseOrder',
    name: 'agrMyPurchaseOrder',
    meta: {
      title: '我的采购订单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMyPurchaseOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrMyPurchaseOrder/agrMyPurchaseOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单异常变更确认
  {
    path: 'agrExceptionConfirmOrder',
    name: 'agrExceptionConfirmOrder',
    meta: {
      title: '订单异常变更确认',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrExceptionConfirmOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderMenu/agrExceptionConfirmOrder/agrExceptionConfirmOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-销售订单查询
  {
    path: 'agrSalesOrderQuery',
    name: 'agrSalesOrderQuery',
    meta: {
      title: '销售订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrSalesOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrSalesOrderQuery/agrSalesOrderQuery.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-采购订单查询
  {
    path: 'agrPurchaseOrderQuery',
    name: 'agrPurchaseOrderQuery',
    meta: {
      title: '采购订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrPurchaseOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrPurchaseOrderQuery/agrPurchaseOrderQuery.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-三方交易模式订单查询
  {
    path: 'agrMatchingOrderQuery',
    name: 'agrMatchingOrderQuery',
    meta: {
      title: '三方交易模式订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMatchingOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/agrOrderCountMenu/agrMatchingOrderQuery/agrMatchingOrderQuery.vue');
    }
  }, // 内部采购企业-商城订单管理-我的商城订单-我的商城订单列表
  // ---------------------------anntan start----------------------------------
  {
    // 内部采购企业-订单管理-无协议订单管理-我的订单-我的订单-全部订单
    path: 'unagrMyOrder',
    name: 'unagrMyOrder',
    meta: {
      title: '我的订单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrMyOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrMyOrder/unagrMyOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-到货确认
    path: 'unagrArrivalConfirmation',
    name: 'unagrArrivalConfirmation',
    meta: {
      title: '到货确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrMyOrder/unagrArrivalConfirmation.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-到货验收
    path: 'unagrConfirmReciving',
    name: 'unagrConfirmReciving',
    meta: {
      title: '到货验收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrMyOrder/unagrConfirmReciving.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-订单详情
    path: 'unpurAgrOrderDetail',
    name: 'unpurAgrOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unpurAgrOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-订单详情
    path: 'unagrOrderDetail',
    name: 'unagrOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-收发货
    path: 'unagrReceivingAddressDetail',
    name: 'unagrReceivingAddressDetail',
    meta: {
      title: '收发货详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrReceivingAddressDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-评价详情
    path: 'unagrEvaluationOrderDetail',
    name: 'unagrEvaluationOrderDetail',
    meta: {
      title: '评价详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrEvaluate/unagrEvaluationOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-追评
    path: 'unagreviewOrder',
    name: 'unagreviewOrder',
    meta: {
      title: '追评',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrEvaluate/unagreviewOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-追评
    path: 'unevaluate',
    name: 'unevaluate',
    meta: {
      title: '评价',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrEvaluate/unevaluate.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-我的取消申请-我的取消申请列表
    path: 'unagrMyCancleApply',
    name: 'unagrMyCancleApply',
    meta: {
      title: '我的取消申请',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrMyCancleApply']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrMyCancleApply/unagrMyCancleApply.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-我的取消申请-取消申请详情
    path: 'unagrCancleOrderDetail',
    name: 'unagrCancleOrderDetail',
    meta: {
      title: '取消申请详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrMyCancleApply/unagrCancleOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-订单审批
    path: 'unagrApprovalOrder',
    name: 'unagrApprovalOrder',
    meta: {
      title: '订单审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrApprovalOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrApprovalOrder/unagrApprovalOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-订单审批提交
    path: 'unagrApprovalOrderDetail',
    name: 'unagrApprovalOrderDetail',
    meta: {
      title: '订单审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrApprovalOrder/unagrApprovalOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-到货验收
    path: 'unagrArrivalAcceptance',
    name: 'unagrArrivalAcceptance',
    meta: {
      title: '到货验收',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrArrivalAcceptance']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrArrivalAcceptance/unagrArrivalAcceptance.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-售后管理
    path: 'unagrAfterSalesManagement',
    name: 'unagrAfterSalesManagement',
    meta: {
      title: '售后管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrAfterSalesManagement']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrAfterSalesManagement/unagrAfterSalesManagement.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-售后管理
    path: 'unagrAfterSalesSubmit',
    name: 'unagrAfterSalesSubmit',
    meta: {
      title: '售后申请提交',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrAfterSalesManagement/unagrAfterSalesSubmit.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-服务单详情
    path: 'unagrViewServiceDetail',
    name: 'unagrViewServiceDetail',
    meta: {
      title: '服务单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrAfterSalesManagement/unagrViewServiceDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-售后管理
    path: 'unagrExceptionOrder',
    name: 'unagrExceptionOrder',
    meta: {
      title: '订单异常变更',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrExceptionOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrExceptionOrder/unagrExceptionOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-数量变更发起
    path: 'unagrExceptionOrderChange',
    name: 'unagrExceptionOrderChange',
    meta: {
      title: '数量变更发起',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrExceptionOrder/unagrExceptionOrderChange.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-采购订单管理
    path: 'unagrMyPurchaseOrder',
    name: 'unagrMyPurchaseOrder',
    meta: {
      title: '采购订单管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrMyPurchaseOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrMyPurchaseOrder/unagrMyPurchaseOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-订单异常变更
    path: 'unagrExceptionConfirmOrder',
    name: 'unagrExceptionConfirmOrder',
    meta: {
      title: '订单异常变更确认',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrExceptionConfirmOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderMenu/unagrExceptionConfirmOrder/unagrExceptionConfirmOrder.vue');
    }
  }, // ---------------------------anntan end----------------------------------
  // ------------------------------无协议 lisong sart------------------------------
  {
    // 内部采购企业-订单管理-无协议订单统计查询-订单查询-订单查询列表
    path: 'unagrInquiryOrder',
    name: 'unagrInquiryOrder',
    meta: {
      title: '订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrInquiryOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderCountMenu/unagrInquiryOrder/unagrInquiryOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-售后查询-售后查询列表
    path: 'unagrAfterSalesSearch',
    name: 'unagrAfterSalesSearch',
    meta: {
      title: '售后查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrAfterSalesSearch']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderCountMenu/unagrAfterSalesSearch/unagrAfterSalesSearch.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-售后查询-售后查询列表详情
    path: 'unagrAfterSalesSearchDetail',
    name: 'unagrAfterSalesSearchDetail',
    meta: {
      title: '售后查询',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderCountMenu/unagrAfterSalesSearch/unagrAfterSalesSearchDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-订单异常变更查询 / 订单异常变更查询
    path: 'unagrExceptionOrderQuery',
    name: 'unagrExceptionOrderQuery',
    meta: {
      title: '订单异常变更查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrExceptionOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderCountMenu/unagrExceptionOrderQuery/unagrExceptionOrderQuery.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-订单异常变更查询-订单异常变更详情
    path: 'unagrExceptionOrderQueryDetail',
    name: 'unagrExceptionOrderQueryDetail',
    meta: {
      title: '订单异常变更详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderCountMenu/unagrExceptionOrderQuery/unagrExceptionOrderQueryDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-销售订单查询-销售订单查询列表
    path: 'unagrSalesOrderQuery',
    name: 'unagrSalesOrderQuery',
    meta: {
      title: '销售订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrSalesOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderCountMenu/unagrSalesOrderQuery/unagrSalesOrderQuery.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-采购订单查询-采购订单查询列表
    path: 'unagrPurchaseOrderQuery',
    name: 'unagrPurchaseOrderQuery',
    meta: {
      title: '采购订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrPurchaseOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderCountMenu/unagrPurchaseOrderQuery/unagrPurchaseOrderQuery.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-三方交易模式订单查询-销售订单查询列表
    path: 'unagrMatchingOrderQuery',
    name: 'unagrMatchingOrderQuery',
    meta: {
      title: '三方交易模式订单查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrMatchingOrderQuery']
    },
    component: function component() {
      return import('@/pages/orderModule/unagrOrderCountMenu/unagrMatchingOrderQuery/unagrMatchingOrderQuery.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-我的商城订单-我的商城订单列表
    path: 'myShopOrder',
    name: 'myShopOrder',
    meta: {
      title: '我的商城订单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['myShopOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/shopOrderMenu/myShopOrder/myShopOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-我的商城订单-我的商城订单列表-发货
    path: 'deliverGoods',
    name: 'deliverGoods',
    meta: {
      title: '发货',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/shopOrderMenu/myShopOrder/deliverGoods.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-我的商城订单-我的商城订单列表-发货
    path: 'arrivalRegistration',
    name: 'arrivalRegistration',
    meta: {
      title: '到货登记',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/shopOrderMenu/myShopOrder/arrivalRegistration.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-待处理订单管理 / 待确认取消订单申请
    path: 'shopPendingOrder',
    name: 'shopPendingOrder',
    meta: {
      title: '待处理订单管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['shopPendingOrder']
    },
    component: function component() {
      return import('@/pages/orderModule/shopOrderMenu/shopPendingOrder/shopPendingOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-待处理订单管理 / 待确认取消订单申请-申请单确认
    path: 'applicationFormConfirm',
    name: 'applicationFormConfirm',
    meta: {
      title: '申请单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/shopOrderMenu/shopPendingOrder/applicationFormConfirm.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-待处理订单管理 / 待确认取消订单申请-售后申请确认
    path: 'afterSalesApplyConfirm',
    name: 'afterSalesApplyConfirm',
    meta: {
      title: '售后申请确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/shopOrderMenu/shopPendingOrder/afterSalesApplyConfirm.vue');
    }
  }, {
    // 协议评价
    path: 'agEvaluate',
    name: 'agEvaluate',
    meta: {
      title: '评价',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/evaluateMenu/agEvaluate.vue');
    }
  }, {
    // 订单收银台
    path: 'orderPayMent',
    name: 'orderPayMent',
    meta: {
      title: '支付方式选择',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/components/orderPayMent.vue');
    }
  }, {
    // 供方订单相亲
    path: 'supplierOrderDetails',
    name: 'supplierOrderDetails',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/components/supplierOrderDetails.vue');
    }
  }, {
    // 退款申请
    path: 'refundApply',
    name: 'refundApply',
    meta: {
      title: '退款申请',
      hidden: false
    },
    component: function component() {
      return import('@/pages/orderModule/refundApplyMenu/refundApply.vue');
    }
  }, {
    // 合同下单
    path: 'contractOrder',
    name: 'contractOrder',
    meta: {
      title: '合同下单',
      hidden: false
    },
    component: function component() {
      return import('@/pages/orderModule/contractOrderMenu/contractOrder.vue');
    }
  }, {
    // 合同下单
    path: 'contractOrderDetail',
    name: 'contractOrderDetail',
    meta: {
      title: '合同下单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/contractOrderMenu/contractOrderDetail.vue');
    }
  }, {
    // 退款查询
    path: 'refundQry',
    name: 'refundQry',
    meta: {
      title: '退款查询',
      hidden: false
    },
    component: function component() {
      return import('@/pages/orderModule/refundQryMenu/refundQry.vue');
    }
  }, {
    // 退款详情
    path: 'refundApplyDetail',
    name: 'refundApplyDetail',
    meta: {
      title: '退款详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/orderModule/refundQryMenu/refundApplyDetail.vue');
    }
  }, {
    // 合同下单
    path: 'newContractOrder',
    name: 'newContractOrder',
    meta: {
      title: '合同下单',
      hidden: false
    },
    component: function component() {
      return import('@/pages/orderModule/contractOrderMenu/contractOrder.vue');
    }
  }, {
    //分单
    path: 'reinsurancePolicy',
    name: 'reinsurancePolicy',
    meta: {
      title: '分单页面',
      hidden: false
    },
    component: function component() {
      return import('@/pages/orderModule/reinsurancePolicy/reinsurancePolicy.vue');
    }
  }, {
    // 分单拆分页面
    path: 'reinsurancePolicySplit',
    name: 'reinsurancePolicySplit',
    meta: {
      title: '拆分页面',
      hidden: false
    },
    component: function component() {
      return import('@/pages/orderModule/reinsurancePolicy/reinsurancePolicySplit.vue');
    }
  } // ------------------------------无协议 lisong end------------------------------
  ]
};